
const authentication = require('../../../react-azure-adb2c2').default;




export const list = (values: any) => {
    let tatemonoId = values.tatemonoId
    if (values.isTatemono == 0) {
        tatemonoId = "SysP" + values.tatemonoId
    }

    let url = process.env.REACT_APP_API_BASE_URL + `/api/TmRoomList/` + tatemonoId;
    // let url = `https://localhost:44341/api/TmRoomList/`+tatemonoId;
    //  const url = `https://localhost:44341/api/TmTatemonoList/`;

    // alert(values.isTatemono)
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};












